export const LeaderRoleList = [
  {
    ids: '71',
    name: '王敏',
    role_id: 'role_p6y7xnmgxn8e5om',
    disabled: false,
    checked: true
  },
  {
    ids: '30',
    name: '姜永柱',
    role_id: 'role_7g86o14j31x9vmp',
    disabled: false,
    checked: true
  },
  {
    ids: '38',
    name: '吴炜炜',
    role_id: 'role_w307v1ew015e2pj',
    disabled: false,
    checked: true
  },
  {
    ids: '41',
    name: '许昌',
    role_id: 'role_xqdovn93pnk07m5',
    disabled: false,
    checked: true
  },
  {
    ids: '44',
    name: '周萍英',
    disabled: false,
    role_id: 'role_lo695156jn0m8kj',
    checked: true
  },

  // {
  //   ids: '36',
  //   name: '费林建',
  //   role_id: 'role_p4o78rx8ln63wvg',
  //   disabled: false,
  //   checked: true
  // },
  {
    ids: '76',
    name: '吴斌',
    role_id: 'role_2jx8v13091gq6od',
    disabled: false,
    checked: true
  },
  {
    ids: '37',
    name: '周胜华',
    role_id: 'role_47kml168jrpw06j',
    disabled: false,
    checked: true
  },
  {
    ids: '31',
    name: '程晓东',
    role_id: 'role_kv82z10x0197045',
    disabled: false,
    checked: true
  },
  {
    ids: '52',
    name: '倪世英',
    role_id: 'role_z07myrz0w13p9wv',
    disabled: false,
    checked: true
  },
  // {
  //   ids: '29',
  //   name: '方军',
  //   disabled: false,
  //   checked: true
  // },
  {
    ids: '39',
    name: '张亮',
    role_id: 'role_47l5j1pm61eyzox',
    disabled: false,
    checked: true
  },
  {
    ids: '32',
    name: '吴为东',
    role_id: 'role_ly903r7jgrv6782',
    disabled: false,
    checked: true
  },
  {
    ids: '33',
    name: '杨新程',
    role_id: 'role_j97olnkjl1w0zx6',
    disabled: false,
    checked: true
  },
  {
    ids: '34',
    name: '王润东',
    role_id: 'role_2v7wknvv6nyz56q',
    disabled: false,
    checked: true
  },
  {
    ids: '66',
    name: '李国平',
    disabled: false,
    role_id: 'role_p4o78rx2ln63wvg',
    checked: true
  },
  {
    ids: '75',
    name: '朱国军',
    disabled: false,
    role_id: 'role_lv783rlgm1gy92j',
    checked: true
  },
  {
    ids: '43',
    name: '施利君',
    disabled: false,
    role_id: 'role_g3yl7r8le14mdv2',
    checked: true
  },

  {
    ids: '45',
    name: '秦剑云',
    disabled: false,
    role_id: 'role_lv783rlmm1gy92j',
    checked: true
  },
  {
    ids: '40',
    name: '郭荣',
    role_id: 'role_p6y7xnmmxn8e4om',
    disabled: false,
    checked: true
  },
  {
    ids: '42',
    name: '郑建明',
    disabled: false,
    role_id: 'role_qvzxe1dwdn276y9',
    checked: true
  }
];
